import Backbone from 'backbone';
import Section from 'ef/models/section';
import _ from 'lodash';
import EF from 'ef/ef';

/*/ ## EF.Collections.SectionsCollection
//
// Collection for the survey sections */

const SectionsCollection = Backbone.Collection.extend({
  model: Section,
});

_.extend(EF.Collections, {
  SectionsCollection: SectionsCollection,
});

export default SectionsCollection;
